import React, { useState, useEffect } from 'react';
import { setUnavailableDays } from '../../redux/eventSlice';
import { useDispatch } from 'react-redux';

interface Option {
  value: string;
  label: string;
  isChecked: boolean;
}

interface CheckboxSelectFieldProps {
  id: string;
  label: string;
  extra?: string;
  options: Option[];
  unavailableDays?: string[];
  payloadUnavailableDays?:string[];
}

const NonWorkingDaysCheckboxSelectField: React.FC<CheckboxSelectFieldProps> = ({ id, label, extra, options, unavailableDays, payloadUnavailableDays }) => {
  const [selectedoptions, setSelectedOptions] = useState(options);
  const dispatch = useDispatch();
  
    useEffect(() => {
      if(unavailableDays && unavailableDays.length > 0) {
        unavailableDays.forEach((key:string) => {
       
          dispatch(setUnavailableDays({value:key,status:true}));

          setSelectedOptions(currentOptions => currentOptions.map(option => 
            option.value === key ? { ...option, isChecked: true } : option
          ));

        });
      }
    }, [unavailableDays]);
  
    useEffect(() => {
      if(payloadUnavailableDays && payloadUnavailableDays.length > 0) {
        payloadUnavailableDays.forEach((key:string) => {
          setSelectedOptions(currentOptions => currentOptions.map(option => 
            option.value === key ? { ...option, isChecked: true } : option
          ));

        });
      }
    }, [payloadUnavailableDays]);

  const handleCheckboxChange = (optionValue: string,isChecked:boolean) => {
 
    setSelectedOptions(currentOptions => currentOptions.map(option => 
      option.value === optionValue ? { ...option, isChecked: isChecked } : option
    ));

    dispatch(setUnavailableDays({value:optionValue,status:isChecked}));
  
  };
  
  return (
    <div className={`${extra}`}>
      <label htmlFor={id} className="text-sm text-navy-700 dark:text-white ml-3 font-bold">
        {label}
      </label>
      <div id={id} className="mt-2 w-full max-h-[200px] overflow-y-auto rounded-xl border p-3">
        {selectedoptions.map((option) => (
          <div key={option.value} className="flex items-center mb-2">
            <input
              type="checkbox"
              id={`checkbox-${option.value}`}
              checked={option.isChecked}
              onChange={(e) => handleCheckboxChange(option.value, e.target.checked)}
              className="mr-2"
            />
            <label htmlFor={`checkbox-${option.value}`} className="font-semibold text-gray-700">
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NonWorkingDaysCheckboxSelectField;
